var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { pxToRem } from '../../utils';
var attachmentStyles = {
    root: function (_a) {
        var props = _a.props, variables = _a.variables;
        return (__assign({ position: 'relative', display: 'inline-flex', alignItems: 'center', width: pxToRem(300), minHeight: pxToRem(48), padding: pxToRem(8), marginBottom: pxToRem(2), marginRight: pxToRem(2), background: variables.backgroundColor, color: variables.textColor, outline: 0 }, (props.isFromKeyboard && {
            ':focus': {
                outline: ".2rem solid " + variables.focusOutlineColor,
            },
        }), ((props.actionable || props.onClick) && {
            cursor: 'pointer',
            ':hover': {
                background: variables.backgroundColorHover,
            },
        })));
    },
    content: function (_a) {
        var props = _a.props;
        return ({
            flex: 1,
        });
    },
    header: function (_a) {
        var props = _a.props, variables = _a.variables;
        return ({
            fontSize: variables.headerFontSize,
            fontWeight: variables.headerFontWeight,
            lineHeight: variables.headerLineHeight,
        });
    },
    description: function (_a) {
        var props = _a.props, variables = _a.variables;
        return ({
            display: 'block',
            opacity: 0.5,
            fontSize: variables.descriptionFontSize,
            fontWeight: variables.descriptionFontWeight,
            lineHeight: variables.descriptionLineHeight,
        });
    },
    icon: function (_a) {
        var props = _a.props, variables = _a.variables;
        return ({
            flex: '0 0 auto',
            marginRight: variables.iconSpace,
        });
    },
    action: function (_a) {
        var props = _a.props;
        return ({
            flex: '0 0 auto',
        });
    },
    progress: function (_a) {
        var props = _a.props, variables = _a.variables;
        return ({
            transition: 'width 0.2s',
            position: 'absolute',
            display: 'block',
            bottom: 0,
            left: 0,
            width: props.progress + "%",
            maxWidth: '100%',
            height: pxToRem(variables.progressHeight),
            background: variables.progressColor,
        });
    },
};
export default attachmentStyles;
